// My view session helpers, backed by the HR app's login (one session for both
// views). The token and profile are stored by store/slices/authSlice; logout
// and clearing the session also happen there.
import { decodeJwt } from "../../utils/jwt";

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch {
    return {};
  }
};

// Linked employee: token claim first (null = not linked), then the stored profile.
export const getEmployeeId = () => {
  try {
    const claims = decodeJwt(localStorage.getItem("accessToken")) || {};
    return claims.employeeId || getStoredUser().employeeId || "";
  } catch {
    return getStoredUser().employeeId || "";
  }
};

export const hasAccessToken = () => !!localStorage.getItem("accessToken");

export const getCompanyId = () => localStorage.getItem("companyId") || "";
